import React, { PropTypes } from "react";
import { connect } from "react-redux";

import BlocsDataTable from "./BlocsDataTable";
import { FormattedMessage } from "react-intl";
import AdminNav from "../AdminNav";
import BlocNav from "./bloc/BlocNav";

class BlocsPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { children, bloc = { name: "" }, blocId } = this.props;

    const title = children ? bloc.name : <FormattedMessage id="admin.title" />;
    const Nav = children ? BlocNav : AdminNav;

    return (
      <div>
        <div className="page-header">
          <div className="main clearfix">
            <div className="main-name">
              <h2>{title}</h2>
            </div>
          </div>
          <Nav blocId={blocId} />
        </div>
        {!!children ? (
          <div className="sub-container">{children}</div>
        ) : (
          <div className="sub-container">
            <BlocsDataTable />
          </div>
        )}
      </div>
    );
  }
}

BlocsPage.propTypes = {
  children: PropTypes.node,
  bloc: PropTypes.object,
  blocId: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  const blocs = state.data.blocs || {};
  const bloc = blocs.active || {};

  return {
    bloc,
    blocId: ownProps.params.blocId,
  };
}

export default connect(mapStateToProps, null)(BlocsPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/BlocsPage.js